import React from 'react'
import { Button, Spinner, Menu, MenuItem } from '@blueprintjs/core';
import { Suggest } from '@blueprintjs/select';
import { observable, action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Api } from 'services/Api';
import axios from 'axios';
import debounce from 'services/debounce';

const LocationRenderer = (location, { handleClick, modifiers }) => {
  return (
    <MenuItem
      active={modifiers.active}
      key={location.id}
      label={location.attributes.email}
      onClick={handleClick}
      text={location.attributes.full_address}
    />
  );
};

const ListRenderer = ({ items, itemsParentRef, query, renderItem, loading, failed }) => {
  const renderedItems = items.map(renderItem).filter(item => item != null);
  return (
    <Menu ulRef={itemsParentRef}>
      {
        failed && !loading && <MenuItem disabled={true} text={'Failed to load results :('} />
      }
      {
        loading && !failed && <MenuItem disabled={true} text={'Loading..'} label={<Spinner size={20}/>} />
      }
      {
        !loading && !failed && <MenuItem
                      disabled={true}
                      text={`Found ${renderedItems.length} locations matching "${query}"`}
                    />
      }
      {renderedItems}
    </Menu>
  );
}

@observer
class LocationAutocomplete extends React.Component {

  @observable loading = true;
  @observable failed = false;
  @observable results = [];
  @observable selectedLocation = null;
  @observable scope = null;

  componentDidUpdate(){
    if(this.props.value){
      this.selectedLocation = this.props.value;
    }
  }

  componentDidMount() {
    let {
      selectedLocationId
    } = this.props;
    if (selectedLocationId) {
      let promise = Api.get(`/locations/${selectedLocationId}`)
      promise.then(response => {
        this.selectedLocation = response.data.data;
      })
    }
    if(this.props.value){
      this.selectedLocation = this.props.value;
    }
  }

  @action
  onQueryChange(query) {
    let { scope } = this.props;
    this.failed = false;
    this.loading = true;
    let search = { term: query, per_page: 50, page: 1, order: { name: 'asc' } };
    if(scope){
      search['where'] = scope;
    }
    let promise = Api.post('/locations/search', { search: search })
    promise
      .then(this.onLocationsLoad.bind(this))
      .catch(this.onLocationsLoadFail.bind(this))
    return promise;
  }

  @action
  onLocationsLoadFail(error) {
    if (axios.isCancel(error)) {
      this.loading = true;
    } else {
      this.loading = false;
      this.failed = true;
    }
  }

  @action
  onLocationsLoad(response) {
    this.loading = false;
    this.failed = false;
    this.results = response.data.data;
  }

  @action
  onLocationSelect(location) {
    this.selectedLocation = location;
    this.props.onLocationSelect(location);
  }

  @action
  clearSelectedLocation() {
    this.selectedLocation = null;
    this.props.onLocationSelect(null);
    this.props.onLocationClear();
  }

  render() {
    let {
      failed,
      results,
      onQueryChange,
      loading,
      onLocationSelect,
      selectedLocation,
      clearSelectedLocation,
      props: {
        inputProps
      }
    } = this;
    return(
      <div  className="client-name-field">
        {
          selectedLocation ? <Button 
              text={this.selectedLocation.attributes.name} 
              rightIcon='cross'
              onClick={clearSelectedLocation.bind(this)}
            /> : <Suggest
              inputProps={{
                icon: 'cross',
                placeholder: 'Search location...',
                onClick: onQueryChange.bind(this, ""),
                ...inputProps
              }}
              closeOnSelect={true}
              resetOnQuery={true}
              resetOnSelect={true}
              popoverProps={{ minimal: true }}
              onQueryChange={debounce(onQueryChange.bind(this)).bind(this)}
              items={toJS(results)}
              itemRenderer={LocationRenderer}
              itemListRenderer={(props) => <ListRenderer {...props} loading={loading} failed={failed} />}
              inputValueRenderer={(location) => location.attributes.full_address }
              onItemSelect={onLocationSelect.bind(this)}
            />
        }
      </div>
    )
  }
}

LocationAutocomplete.propTypes = {
  inputProps: PropTypes.object,
  onLocationSelect: PropTypes.func.isRequired
}

export default LocationAutocomplete;